import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { propOr } from 'ramda'
import ExpandablePanel from 'components/ExpandablePanel'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import { selectCurrentUser } from 'modules/auth/ducks/selectors'
import {
  readNavigationLayout,
  writeNavigationLayout,
  NAV_LAYOUT_FLAT,
  NAV_LAYOUT_GROUPED,
  NAV_LAYOUT_EVENT
} from 'utils/navigationLayout'

const NavigationLayoutPanel = () => {
  const currentUser = useSelector(selectCurrentUser)
  const role = propOr('', 'role', currentUser)
  const [mode, setMode] = useState(readNavigationLayout)

  useEffect(() => {
    const onChange = () => setMode(readNavigationLayout())
    window.addEventListener(NAV_LAYOUT_EVENT, onChange)
    return () => window.removeEventListener(NAV_LAYOUT_EVENT, onChange)
  }, [])

  if (role !== 'admin' && role !== 'worker') {
    return null
  }

  const handleChange = e => {
    const v = e.target.value
    writeNavigationLayout(v)
    setMode(v)
  }

  return (
    <ExpandablePanel title='Układ menu bocznego'>
      <FormControl component='fieldset'>
        <RadioGroup value={mode} onChange={handleChange}>
          <FormControlLabel
            value={NAV_LAYOUT_FLAT}
            control={<Radio color='primary' />}
            label='Pełna lista'
          />
          <FormControlLabel
            value={NAV_LAYOUT_GROUPED}
            control={<Radio color='primary' />}
            label='Pogrupowane (zwijane sekcje)'
          />
        </RadioGroup>
      </FormControl>
    </ExpandablePanel>
  )
}

export default NavigationLayoutPanel
